import type * as lazyIndex from './lazyIndex';
import './orchestrators/NewMessageV3Orchestrator';
import type { LazyActionOptions } from 'owa-bundling';
import { LazyAction, LazyModule, registerLazyOrchestrator } from 'owa-bundling';

const lazyActionOptions: LazyActionOptions = { captureBundleTime: true };
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailMessageActions"*/ './lazyIndex'),
    { name: 'MailMessageActions' }
);

export const lazyNewMessage: LazyAction<typeof lazyIndex.newMessage, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.newMessage, lazyActionOptions);
export const lazyPrintConversation: LazyAction<
    typeof lazyIndex.printConversation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.printConversation);
export const lazyReplyToItem: LazyAction<typeof lazyIndex.replyToItem, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.replyToItem);
export const lazyForwardItem: LazyAction<typeof lazyIndex.forwardItem, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.forwardItem);
export const lazyForwardItemAsAttachment: LazyAction<
    typeof lazyIndex.forwardItemAsAttachment,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.forwardItemAsAttachment);
export const lazyPrintItem: LazyAction<typeof lazyIndex.printItem, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.printItem);
export const lazyShowConversationInImmersiveReader: LazyAction<
    typeof lazyIndex.showConversationInImmersiveReader,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.showConversationInImmersiveReader);
export const lazyReplyWithText: LazyAction<typeof lazyIndex.replyWithText, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.replyWithText);
export { default as ReplyWithTextFeatures } from './contract/ReplyWithTextFeatures';
export const lazyResendMessage: LazyAction<typeof lazyIndex.resendMessage, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.resendMessage);
export const lazyGetMailboxInfo: LazyAction<typeof lazyIndex.getMailboxInfo, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getMailboxInfo);

import onMailServiceNewMessage from 'owa-app-host-actions/lib/actions/onMailServiceNewMessage';
import onMailServiceForwardMessage from 'owa-app-host-actions/lib/actions/onMailServiceForwardMessage';
import onMailServiceReplyReplyAllToMessage from 'owa-app-host-actions/lib/actions/onMailServiceReplyReplyAllToMessage';
import onMailServiceOpenItem from 'owa-app-host-actions/lib/actions/onMailServiceOpenItem';

registerLazyOrchestrator(
    onMailServiceNewMessage,
    lazyModule,
    m => m.onMailServiceNewMessageOrchestrator
);
registerLazyOrchestrator(
    onMailServiceForwardMessage,
    lazyModule,
    m => m.onMailServiceForwardMessageOrchestrator
);
registerLazyOrchestrator(
    onMailServiceReplyReplyAllToMessage,
    lazyModule,
    m => m.onMailServiceReplyReplyAllToMessageOrchestrator
);
registerLazyOrchestrator(
    onMailServiceOpenItem,
    lazyModule,
    m => m.onMailServiceOpenItemOrchestrator
);
